/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Heading = 'Website.ProductReview.MyProfile.DeleteReviewConfirmation.Heading';
export const Message = 'Website.ProductReview.MyProfile.DeleteReviewConfirmation.Message';
export const ConfirmButton = 'Website.ProductReview.MyProfile.DeleteReviewConfirmation.ConfirmButton';
